/**
 * Returns true if this is a variant deployment (e.g., solstice).
 * Variant deployments have VITE_BACKEND_API_URL set to a custom backend URL.
 * Used to disable analytics (Segment, Datadog) in variant environments.
 *
 * This is in its own file to avoid circular dependencies when imported
 * early in the initialization process.
 */
export const IS_VARIANT_DEPLOYMENT = Boolean(import.meta.env.VITE_BACKEND_API_URL);
